export default __webpack_public_path__ + "static/media/snooker.4f4c2d5c.webp";